// Polyfills are placed here to get imported before any bootstrapping code runs
//
// NOTE: NEVER add a polyfill that is not part of a spec implemented at least in all the modern browsers (Edge, Chrome, Firefox)

// we need these polyfills because of Safari
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'raf/polyfill';
/* eslint-disable-next-line owa-custom-rules/forbid-empty-import-statements-from-modules -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!, replace this line with a justification or fix the issue.
 *	> Empty import statements from non-relative modules are not allowed. Either import something specific or remove the import. */
import 'intersection-observer';
// Reflect.hasOwnMetadata is used at runtime in decorators in esbuild
//
// Normally this isn't needed, and is handled by typescript
// transpilation at compile-time.
//
// However, when running in esbuild, this isn't handled for us, so we require
// this polyfill manually here.
//
// This polyfill dev check was removed to fix the issue with importing @editor/client-textutils SentenceSeparator
// which is using injectable decorator from inversify
// https://github.com/inversify/InversifyJS/blob/c68e60dc410485956cd21c345ed6f3b4ed4d5abb/src/annotation/injectable.ts#L9
require('reflect-metadata');

// crypto.randomUUID polyfill for older browsers that support
// crypto.getRandomValues but not crypto.randomUUID
if (typeof crypto !== 'undefined' && !crypto.randomUUID) {
    crypto.randomUUID = function randomUUID(): `${string}-${string}-${string}-${string}-${string}` {
        const bytes = new Uint8Array(16);
        crypto.getRandomValues(bytes);
        // Set version 4 (0100) and variant 10xx per RFC 4122
        bytes[6] = (bytes[6] & 15) | 64;
        bytes[8] = (bytes[8] & 63) | 128;
        const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
        return `${hex.slice(0, 8)}-${hex.slice(8, 12)}-${hex.slice(12, 16)}-${hex.slice(
            16,
            20
        )}-${hex.slice(20, 32)}` as `${string}-${string}-${string}-${string}-${string}`;
    };
}

// Object.hasOwn polyfill for ES2022 hasOwn method
// Used by react-virtuoso library and other modern packages
if (!Object.hasOwn) {
    Object.hasOwn = function hasOwn(obj: object, prop: string | number | symbol): boolean {
        return Object.prototype.hasOwnProperty.call(obj, prop);
    };
}
